import { CommonRequestOptions, makeRequest } from '../makeRequest';
import { StageCompletionRecord } from './get-course-assignment-details';

export type GetAssignmentStagesCompletionsOptions = CommonRequestOptions & {
   page?: number;
   limit?: number;
   userid?: number | null;
   order?: 'ASC' | 'DESC';
   scope?: 'user' | 'team';
};

export type GetAssignmentStagesCompletionsResponse = {
   total: number;
   hasMore: boolean;
   stages: StageCompletionRecord[];
};

export function getAssignmentStagesCompletions(
   assignmentid: number,
   { page, limit, scope, userid, order, ...common }: GetAssignmentStagesCompletionsOptions = {}
): Promise<GetAssignmentStagesCompletionsResponse> {
   return makeRequest('get', `course_assignments/${assignmentid}/stages/completions`, {
      ...common,
      query: {
         limit,
         order,
         scope,
         userid,
         offset: page,
      },
   });
}
